import { render, staticRenderFns } from "./another-profile.vue?vue&type=template&id=5724f63d&scoped=true&"
import script from "./another-profile.vue?vue&type=script&lang=js&"
export * from "./another-profile.vue?vue&type=script&lang=js&"
import style0 from "./another-profile.vue?vue&type=style&index=0&id=5724f63d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724f63d",
  null
  
)

export default component.exports